import React from 'react'
import { Form } from 'semantic-ui-react'
import { assignableRoles } from '../../../common/config'

const RoleFilter = ({ value, onChange, ...remainingProps }) => {
  const roleOptions = Object.keys(assignableRoles).reduce((types, key) => {
    types.push({ value: key, text: assignableRoles[key] })
    return types
  }, [])
  if (!remainingProps.multiple) assignableRoles.unshift({ value: '', text: 'Vše' })
  let realValue = value
  if (!realValue && remainingProps.multiple) realValue = []
  return (
    <Form.Select
      options={roleOptions}
      value={realValue}
      onChange={(e, value) => onChange(value)}
      {...remainingProps}
    />
  )
}

RoleFilter.defaultProps = {
  multiple: false,
  value: '',
}

RoleFilter.propTypes = {
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default RoleFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/RoleFilter.js